import ErrorComponent from "@/components/atoms/ErrorComponent";
import CompanyStatusHeader from "@/components/molecules/card-headers/companies/CompanyStatusHeader";
import CompanyStatusEditCard from "@/components/molecules/cards/companies/CompanyStatusEditCard";
import { UUID_REGEX } from "@/constants/regexs";
import { FC } from "react";
import { useParams } from "react-router-dom";

const CompanyStatusEditView: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page formalys-edit-page">
      <CompanyStatusHeader id={id} isEdit />
      <CompanyStatusEditCard id={id} />
    </div>
  );
};

export default CompanyStatusEditView;
